import FastImage from "@d11/react-native-fast-image";
import React, { useCallback, useEffect } from "react";
import { View } from "native-base";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import PressableWrap from "../../../../Universal/Buttons/PressableColorWrap/PressableColorWrap";
import { GalleryThumbnailProps } from "./types";

const GalleryThumbnail: React.FC<GalleryThumbnailProps> = React.memo(
  ({ image, index, isActive, imageSwiperRef, isSmallVersion, styles }) => {
    const activeProgress = useSharedValue(isActive ? 1 : 0);

    useEffect(() => {
      activeProgress.value = withTiming(isActive ? 1 : 0, { duration: 140 });
    }, [activeProgress, isActive]);

    const handlePress = useCallback(() => {
      imageSwiperRef.current?.goToIndex(index);
    }, [imageSwiperRef, index]);

    const overlayAnimatedStyle = useAnimatedStyle(() => ({
      opacity: activeProgress.value,
    }));

    return (
      <PressableWrap onPress={handlePress} style={styles.thumbCardPress}>
        <View
          style={[
            styles.thumbCard,
            isSmallVersion ? styles.thumbCardSmall : null,
          ]}
        >
          <FastImage
            source={{ uri: image }}
            style={styles.thumbImage}
            resizeMode="cover"
          />
          <Animated.View
            pointerEvents="none"
            style={[styles.thumbCardOverlay, overlayAnimatedStyle]}
          />
        </View>
      </PressableWrap>
    );
  }
  ,
  (prevProps, nextProps) =>
    prevProps.image === nextProps.image &&
    prevProps.index === nextProps.index &&
    prevProps.isActive === nextProps.isActive &&
    prevProps.isSmallVersion === nextProps.isSmallVersion &&
    prevProps.imageSwiperRef === nextProps.imageSwiperRef &&
    prevProps.styles === nextProps.styles
);

export default GalleryThumbnail;
